import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { withRouter } from 'react-router'
import Icon from '@material-ui/core/Icon'
const propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object
}
const styles = theme => ({
  tabs: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    borderRadius: 0
  },
  tab: {
    color: 'white',
    maxWidth: 'none'
  }
})
const menu = [
  {
    index: 0,
    label: 'Home',
    iconName: 'home',
    route: '/home',
    sub: ['/table', '/bar']
  },
  {
    index: 1,
    label: 'Produits',
    iconName: 'local_bar',
    route: '/products',
    sub: []
  },
  {
    index: 2,
    label: 'Clients',
    iconName: 'contacts',
    route: '/customers',
    sub: []
  },
  {
    index: 3,
    label: 'Casiers',
    iconName: 'lock',
    route: '/lockers',
    sub: []
  },
  {
    index: 4,
    label: 'Historique',
    iconName: 'history',
    route: '/history',
    sub: []
  }
]

class FooterContainer extends Component {
  state = {
    tabValue: 0
  }
  handleChange = (event, value) => {
    const route = menu[value].route
    this.props.history.replace(route)
    this.setState({ tabValue: value })
  }

  componentDidMount() {
    const { pathname } = this.props.location
    let index = 0
    menu.map(item => {
      if (pathname.startsWith(item.route)) {
        index = item.index
        return null
      }
      item.sub.forEach(sub => {
        index = pathname.startsWith(item.sub) ? item.index : item.index
      })
      return null
    })
    this.setState({ tabValue: index })
  }
  componentWillReiceiveProps(nextProps) {
    const { pathname } = nextProps.location
    let index = 0
    menu.map(item => {
      if (pathname.startsWith(item.route)) {
        index = item.index
        return null
      }
      item.sub.forEach(sub => {
        index = pathname.startsWith(item.sub) ? item.index : item.index
      })
      return null
    })
    this.setState({ tabValue: index })
  }
  render() {
    const { classes } = this.props
    return (
      <Tabs
        fullWidth
        value={this.state.tabValue}
        onChange={this.handleChange}
        centered
        scrollButtons="off"
        indicatorColor="secondary"
        className={classes.tabs}>
        {menu.map(item => {
          return (
            <Tab
              key={item.index}
              className={classes.tab}
              label={item.label}
              icon={
                <Icon color="inherit" className="material-icons">
                  {item.iconName}
                </Icon>
              }
            />
          )
        })}
      </Tabs>
    )
  }
}

const mapStateToProps = state => {
  return {}
}
const mapDispatchToProps = dispatch => {
  return {}
}

FooterContainer.propTypes = propTypes
export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter(withStyles(styles)(FooterContainer))
)



// WEBPACK FOOTER //
// ./src/containers/FooterContainer.js